import { FormattedMessage } from 'react-intl';
import React from 'react';
import bemify from 'bemify-js';

import BashCodeBlock from '../components/BashCodeBlock';
import Paragraph from '../components/Paragraph';
import StepTitle from '../components/StepTitle';

const bem = bemify('view-logs');

const ViewLogs = () => (
  <div className={bem()}>
    <StepTitle>
      <FormattedMessage defaultMessage="View Logs" id="headings-view-logs" />
    </StepTitle>
    <Paragraph>
      <FormattedMessage
        defaultMessage="Holy smokes! You just started this thing a few minutes ago and you've already got a real app deployed. Good job! Ok, what's next? Let's go ahead and find out how to look at our logs."
        id="descriptions-view-logs-introduction"
      />
    </Paragraph>
    <Paragraph>
      <FormattedMessage
        defaultMessage="If you haven't already, go create a Zap with your shiny new app. This will generate some log data for us to look at. In your terminal execute"
        id="descriptions-generate-log-data-before-viewing"
      />
    </Paragraph>
    <BashCodeBlock
      lines={[{ content: 'zapier logs --type=http', isCommand: true }]}
    />
    <Paragraph>
      <FormattedMessage
        defaultMessage="This will show you a bit of info on recent HTTP traffic to your API. If you want get more detailed info use"
        id="descriptions-http-log-command-explanation"
      />
    </Paragraph>
    <BashCodeBlock
      lines={[
        { content: 'zapier logs --type=http --detailed', isCommand: true },
      ]}
    />
    <Paragraph>
      <FormattedMessage
        defaultMessage={
          'In your code you can use z.console.log("my debug message") to add your own debug messages, and check them with'
        }
        id="descriptions-console-log-debug-messages"
      />
    </Paragraph>
    <BashCodeBlock
      lines={[{ content: 'zapier logs --type=console', isCommand: true }]}
    />
    <Paragraph>
      <FormattedMessage
        defaultMessage="For all of the commands in the CLI the help command is super useful to find out what options are available. Execute the following to see other things you can do with zapier logs"
        id="descriptions-logs-help-command-overview"
      />
    </Paragraph>
    <BashCodeBlock lines={[{ content: 'zapier help logs', isCommand: true }]} />
  </div>
);

export default ViewLogs;
